import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["message", "yesBtn"]

  open(event) {
    event.preventDefault()
    const button = event.currentTarget
    const modalId = button.dataset.confirmModalId
    const modal = document.getElementById(modalId)

    if (!modal) return

    modal.style.display = "flex"
  }

  close(event) {
    if (event) event.preventDefault()
    const modal = event.currentTarget.closest(".modal-platforms")
    if (modal) {
      modal.style.display = "none"
    }
  }
}
